// export const API_BASE_URL = "http://localhost:5005";


export const API_BASE_URL = "https://jothilingafpo.com";


// export const API_BASE_URL = "http://103.102.234.198:5005";